import axios from "../../../utils/axios";
import { handleRemoveEmptyParamFromQueryParams } from "../../../utils/helpers";
import { IEditSessionTime, ScheduleFilters } from "../types/schedule.types";

// Endpoint to fetch provider's caseload
export async function fetchWeeklySchedule(params: ScheduleFilters) {
    const response = await axios.get(`/schedules`, {
        params: handleRemoveEmptyParamFromQueryParams(params),
    });

    return response.data;
}

export async function deleteSession(userIds: string[]) {
    const response = await axios.delete(`/users`, {
        data: { user_ids: userIds },
    });
    return response.data;
}

export async function editSessionTime(
    payload: IEditSessionTime,
    sessionHistoryId: string
) {
    const response = await axios.patch(
        `/session_history/${sessionHistoryId}`,
        payload
    );

    return response.data;
}
